export default __webpack_public_path__ + "static/media/scott-buckley-i-walk-with-ghosts.24570124.mp3";